import { useEffect } from 'react';

const Sketchfab=()=>{

    useEffect(()=>{
        setTimeout(()=>{
            window.close()
        },2000)
    },[])
    
    return(
        <div className='flex h-[100vh] w-[100vw] bg-white text-black'>
            This window will close in 2 seconds. You can close it manually if it doesn&apos;t.
        </div>
    )
}

export { Sketchfab }